export enum OrderTypes {
  PAYSLIP = "payslip",
  MODEL = "model",
  IDENTITY_VERIFICATION = "identity_verification",
  OTHER_DOCUMENT = "other_document",
}
